import { State } from '../state';

export const ReportSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    reports: (state: State) => state.Report,
};